export default "__VITE_ASSET__B0c7WAE9__"